<template>
    <div>
        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active">
                <div
                    v-if="inProgress || transQuestions === null"
                    class="p-5 d-flex justify-content-center align-items-center">
                    <b-spinner variant="yokumiru-admin"/>
                </div>
                <div v-else>
                    <ul class="c-list mb-4">
                        <li v-for="question in transQuestions"
                            class="c-list__item c-list__item--add">
                            <div class="text-left d-block d-lg-flex justify-content-between align-items-center">
                                <div class="vc-question-title mb-2 mb-lg-0">
                                    {{ question.title }}
                                </div>
                                <div class="text-center text-lg-right mb-2 mb-lg-0">
                                    <button
                                        class="btn btn-yokumiru-blue btn-sm mr-1"
                                        @click="modalEdit(question)">編集
                                    </button>
                                    <button
                                        class="btn btn-danger btn-sm"
                                        @click="modalDelete(question)">削除
                                    </button>
                                    <button
                                        class="btn btn-yokumiru-white btn-sm ml-2 text-muted font-weight-bold"
                                        @click="onClickOrder(question, 'up')">↑
                                    </button>
                                    <button
                                        class="btn btn-yokumiru-white btn-sm text-muted font-weight-bold"
                                        @click="onClickOrder(question, 'down')">↓
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="d-flex justify-content-center align-items-center">
                        <button
                            @click="modalAdd"
                            class="btn btn-yokumiru-orange btn-settings">
                            {{ $locale.question }}を追加
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="tabContentImportExport">
            <b-form-file
                v-model="file.object"
                ref="fileinput"
                accept="text/json"
                class="d-none"
                @change="onUpload">
            </b-form-file>
            <button
                @click="onClickImport"
                class="btn btn-yokumiru-orange mr-2">
                インポート
            </button>
            <button
                @click="onClickExport"
                class="btn btn-yokumiru-orange">
                エクスポート
            </button>
        </div>

        <div v-if="question !== null">
            <!--  追加・編集モーダル  -->
            <b-modal
                v-model="modalShow"
                :title="question.id ? `${$locale.question}を編集` : `${$locale.question}を追加`"
                :ok-only="true"
                @ok="handleOk"
                :ok-title="question.id ? '更新' : '追加'"
                ok-variant="yokumiru-orange">
                <form @submit.stop.prevent="postQuestion">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group m-form__group mb-0">
                                    <label>タイプを選択</label>
                                    <select
                                        v-model="question.interview_question_type_id"
                                        @change="onChangeType"
                                        class="form-control m-input m-input--solid">
                                        <option :value="types.multiInput">記述（複数行）</option>
                                        <option :value="types.check">チェックボックス</option>
                                        <option :value="types.radio">ラジオボタン</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="m-form__group form-group">
                                    <div class="d-flex align-items-center">
                                        <label class="col-form-label">必須にする</label>
                                        <div class="vc-toggle-wrapper">
                                            <toggle v-model="question.flg_required"></toggle>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group m-form__group">
                                    <label>質問を入力</label>
                                    <input
                                        v-model="question.title"
                                        :class="{ 'is-invalid' : errors.title }"
                                        class="form-control m-input m-input--air"
                                        maxlength="255">
                                    <div class="text-muted small mt-1">
                                        255文字以内で入力してください
                                    </div>
                                    <div
                                        v-if="errors.title"
                                        class="invalid-feedback d-block">
                                        {{ errors.title[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 「チェックボックス」or「ラジオボタン」選択時 -->
                        <template
                            v-if="question.interview_question_type_id === types.check ||
                            question.interview_question_type_id === types.radio">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group m-form__group">
                                        <label>選択肢を入力</label>

                                        <div v-for="( item, idx ) in question.items" class="mb-2">
                                            <removable-text-input
                                                  :index="idx"
                                                  :invalid="errors.items"
                                                  v-model="question.items[ idx ].title">
                                            </removable-text-input>
                                        </div>

                                        <div v-if="errors.items"
                                             v-text="errors.items[0]"
                                             class="invalid-feedback d-block">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="m-form__group form-group">
                                        <div class="btn btn-outline-success m-btn btn-sm" @click="addItem">
                                            +&nbsp;選択肢を追加
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="m-form__group form-group">
                                        <div class="d-flex align-items-center">
                                            <label class="col-form-label">その他を追加</label>
                                            <div class="vc-toggle-wrapper">
                                                <toggle v-model="question.flg_other"></toggle>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </form>
            </b-modal>

            <!--  削除モーダル  -->
            <b-modal
                v-model="modalDeleteShow"
                title=""
                @ok="handleDelete"
                ok-title= "削除"
                ok-variant="danger"
                cancel-title="キャンセル"
                cancel-variant="yokumiru-gray">
                <form @submit.stop.prevent="deleteQuestion">
                    <p class="text-center">{{ `下記の${$locale.question}項目を削除してもよろしいですか？` }}</p>

                    <div class="modal-body">
                        <h6>タイプ：</h6>

                        <p v-text="question.type.name"></p>

                        <hr>

                        <h6>必須にする：</h6>
                        <p v-text="question.flg_required ? 'ON' : 'OFF'"></p>

                        <hr>

                        <h6>質問：</h6>
                        <p v-text="question.title"></p>
                    </div>
                </form>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'
    import moment from 'moment-timezone'
    import _ from 'lodash'

    export default  {
        props: {
            medicalCourse: {
                type: Object,
                required: true,
            },
        },

        data: function() {
            return {
                inProgress: false,
                question: null,
                transQuestions: null,
                types: constants.interview_question_types,
                file: {
                    name: null,
                    object: null,
                },
                modalShow: false,
                modalDeleteShow: false,
                errors: {},
            }
        },

        watch: {
            medicalCourse: function() {
                this.fetchTransQuestions()
            },
        },

        created: function() {
            this.initQuestion()
            this.fetchTransQuestions()
            bus.$on('on-remove', this.removeItem)
        },

        methods: {
            /**
             * 翻訳問診取得
             */
            fetchTransQuestions: async function() {
                this.transQuestions = null
                const endpoint = constants.admin.medical_courses.endpoint.base

                await axios.get(`${endpoint}/${this.medicalCourse.id}/interview_trans_questions`)
                    .then(({data}) => {
                        this.transQuestions = data.data
                    })
            },

            /**
             * 翻訳問診モーダルの初期化
             *
             * @return {void}
             */
            initQuestion: function() {
                this.question = {
                    interview_question_type_id: this.types.multiInput,
                    type: {},
                    title: null,
                    flg_required: false,
                    flg_other: false,
                    items: [
                        { title: '' },
                    ],
                };
            },

            /**
             * 追加ボタン押下時
             *
             * @return {void}
             */
            modalAdd: function() {
                this.initQuestion()
                this.modalShow = true
            },

            /**
             * 編集ボタン押下時
             */
            modalEdit: function(question) {
                this.question = _.clone(question)
                this.modalShow = true
            },

            /**
             * 削除ボタン押下時
             */
            modalDelete: function(question) {
                this.question = question
                this.modalDeleteShow = true
            },

            /**
             * 選択肢の追加
             *
             * @return {void}
             */
            addItem: function() {
                this.question.items.push( { title: '' } )
            },

            /**
             * 選択肢の削除
             */
            removeItem: function( idx ) {
                if (this.question.items.length < 2) {
                    return
                }
                this.question.items.splice(idx, 1)
            },

            /**
             * 問診タイプ変更時
             */
            onChangeType: function() {
                if ( this.question.items.length < 1 ) {
                    this.addItem()
                }
            },

            /**
             * モーダルウィンドウ
             * 登録クリック時
             */
            handleOk: function (e) {
                e.preventDefault()
                this.postQuestion()
            },

            /**
             * モーダルウィンドウ
             * 削除クリック時
             */
            handleDelete: function(e) {
                e.preventDefault()
                this.deleteQuestion()
            },

            /**
             * 翻訳問診の登録・更新
             *
             * @return {void}
             */
            postQuestion: function() {
                const params = this.prepareItems()

                if (this.question.id) {
                    this.updateQuestion(params)
                } else {
                    this.storeQuestion(params)
                }
            },

            /**
             * 翻訳問診項目の準備
             */
            prepareItems: function() {
                const params = _.clone(this.question)
                params.medical_course_id = this.medicalCourse.id
                params.items = this.question.items.map((item) => item.title)

                return params
            },

            /**
             * 翻訳問診の登録
             *
             * @return {void}
             */
            storeQuestion: function (params) {
                const endpoint = constants.admin.interview_trans_questions.endpoint.base

                axios.post(endpoint, params)
                    .then(({data}) => {
                        bus.$emit('alert-success', `${this.$locale.question}を登録しました。`)
                        this.errors = {}
                        this.transQuestions.push(data.data)
                        this.initQuestion()
                        this.modalShow = false
                    })
                    .catch(({response}) => {
                        if (
                            response
                            && response.hasOwnProperty('data')
                            && response.data.hasOwnProperty('errors')
                        ) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })
            },

            /**
             * 翻訳問診の更新
             */
            updateQuestion: function (params) {
                const endpoint = constants.admin.interview_trans_questions.endpoint.base

                axios.put(`${endpoint}/${this.question.id}`, params)
                    .then(({data}) => {
                        bus.$emit('alert-success', `${this.$locale.question}を更新しました。`)
                        const idx = this.transQuestions.findIndex(question => {
                            return Number(question.id) === Number(data.data.id)
                        })
                        this.transQuestions[idx] = data.data
                        this.initQuestion()
                        this.errors = {}
                        this.modalShow = false
                    })
                    .catch(({response}) => {
                        if (
                            response
                            && response.hasOwnProperty('data')
                            && response.data.hasOwnProperty('errors')
                        ) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })
            },

            /**
             * 翻訳問診の削除
             *
             * @return {void}
             */
            deleteQuestion: function() {
                const id = this.question.id
                const endpoint = constants.admin.interview_trans_questions.endpoint.base

                axios.delete(`${endpoint}/${id}`)
                    .then(() => {
                        bus.$emit('alert-success', `${this.$locale.question}を削除しました。`)
                        this.errors = []

                        const idx = this.transQuestions.findIndex(question => {
                            return Number(question.id) === Number(id)
                        })

                        this.transQuestions.splice(idx, 1)
                        this.initQuestion()
                        this.modalDeleteShow = false
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        } else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })
            },

            /**
             * 問診ソート順更新
             *
             * @param {object} question
             * @param {string} type
             */
            onClickOrder: function (question, type) {
                const endpoint = constants.admin.interview_trans_questions.endpoint.base

                axios.put(`${endpoint}/${question.id}/order`, { type: type })
                    .then(() => {
                        this.fetchTransQuestions()
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    } )
            },

            /**
             * 問診エクスポート
             */
            onClickExport: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = constants.admin.medical_courses.endpoint.base
                const options = { responseType : 'blob' }

                await axios.get(`${endpoint}/${this.medicalCourse.id}/interview_trans_questions/export`, options)
                    .then((response) => {
                        const blob = new Blob([response.data], {
                            type: response.data.type,
                        })
                        saveAs(blob, `${this.medicalCourse.name}_${this.$locale.question}_${moment().format('YYYYMMDD')}.json`)
                    })
                    .catch(() => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    })

                this.inProgress = false
            },

            /**
             * 問診インポート
             */
            onClickImport: function () {
                this.$refs.fileinput.$el.children[0].click()
            },

            /**
             * 問診インポート（ファイルアップロード時）
             */
            onUpload: async function (e) {
                if (this.inProgress) return
                this.inProgress = true

                const elem = e.target
                this.errors = {}

                if (elem.files.length > 0) {
                    if (elem.files[0].size > 10240000) {
                        this.errors = { file: ['ファイルサイズは10MB以内にしてください。'] }
                        return
                    }

                    this.file.object = elem.files[0]
                    this.file.name = this.file.object.name

                    const endpoint = constants.admin.medical_courses.endpoint.base
                    const data = this.buildFormData()
                    const options = { headers: { 'Content-Type': 'multipart/form-data' } }

                    await axios.post(`${endpoint}/${this.medicalCourse.id}/interview_trans_questions/import`, data, options)
                        .then(() => {
                            this.fetchTransQuestions()
                            bus.$emit('alert-success', `${this.$locale.question}をインポートしました。`)
                        })
                        .catch(({response}) => {
                            if (
                                response
                                && response.hasOwnProperty('data')
                                && response.data.hasOwnProperty('errors')
                            ) {
                                this.errors = response.data.errors
                                bus.$emit('alert-danger')
                            }
                            else {
                                bus.$emit('alert-danger', 'システムエラーが発生しました。')
                            }
                        })
                }

                this.initFile()
                this.inProgress = false
            },

            /**
             * FormData作成
             * @return {FormData}
             */
            buildFormData: function () {
                const formData = new FormData()

                if (this.file.object !== null && this.file.object !== void (0)) {
                    formData.append('file', this.file.object)
                }

                return formData
            },

            /**
             * 状態初期化
             */
            initFile: function () {
                this.file = {
                    name: null,
                    object: null,
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .btn-settings {
        width: 100%;
        max-width: 200px;
        display: block;
        margin: 0 auto;
    }

    .vc-question-title {
        max-width: 685px;

        @media screen and (max-width: 1199px) {
            max-width: 545px;
        }
    }

    .vc-toggle-wrapper {
        margin-left: 6px;
    }

    .tab-medical-course-name {
        color: #333;
        font-size: 14px;
        font-weight: bold;
    }

    a.active {
        .tab-medical-course-name {
            color: #fff;
        }
    }

    .tab-doctor-menu-title {
        font-size: 15px;
        font-weight: bold;
    }

    .tabContentBody {
        position: relative;
        padding-bottom: 120px;
    }

    .tabContentImportExport {
        position: absolute;
        right: 20px;
        bottom: 20px;
    }
</style>
